import { type ReactNode } from 'react'

import { makeTableColumnsLayout } from '../shared/makeTableColumnsLayout'

const TABLE_COLUMNS_SPEC = [
    //from figma
    { key: 'select', width: 31, sticky: true },
    { key: 'creationDate', width: 57, sticky: true },
    { key: 'name', width: 200, sticky: true },
    { key: 'status', width: 100, sticky: true },
    { key: 'marking', width: 168 },
    { key: 'creative', width: 190 },
    { key: 'link', width: 120 },
    { key: 'budget', width: 88 },
    { key: 'subscribers', width: 61 },
    { key: 'averageReach', width: 93 },
    { key: 'err', width: 39 },
    { key: 'CPMForcasted', width: 72 },
    { key: 'publishedAt', width: 96 },
    { key: 'publishingDeletionDate', width: 82 },
    { key: 'reach', width: 57 },
    { key: 'CPM', width: 72 },

    //not from figma
    { key: 'subscribed', width: 64 },
    { key: 'subscribedPerDay', width: 64 },
    { key: 'CTR', width: 64 },
    { key: 'CPS', width: 64 },
    { key: 'unsubscribed', width: 64 },
    { key: 'unsubscriptionPercentage', width: 64 },
    { key: 'totalSubscribed', width: 64 },
    { key: 'total_CPS', width: 64 },
] as const

export const TABLE_COLUMNS_LAYOUT = makeTableColumnsLayout(TABLE_COLUMNS_SPEC)

export type TableColumnKey = (typeof TABLE_COLUMNS_SPEC)[number]['key']

export type TableReactNodeRecord = Record<TableColumnKey, ReactNode>
